module.exports = __webpack_public_path__ + "static/media/classic2.23241fda.jpg";